<template>
    <div class="well ovx-auto">
        <div class="flex-level">
            <div class="flex fs-4 bold">
                {{ $l10n.__('Achats externes') }}
            </div>
            <div class="flex aright">
                <CompassButton
                    :label="$t.__('common.actions.impact_profit')"
                    type="secondary"
                    :disabled="impactButtonIsDisable"
                    @click="impact()"
                />
                <CompassButton
                    :label="$t.__('documents.overview.tab.margin.Purchase.link_purchase')"
                    type="secondary"
                    :disabled="!canImpact"
                    :onclick="`purchaseTools.linkTo('${doctype}', ${docid});`"
                />
            </div>
        </div>

        <el-table ref="multipleTable" :data="purchases" @selection-change="handleSelectionChange">
            <el-table-column type="selection" :selectable="canProcess" property="processMargin">
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.impact_profit')">
                <template #default="scope">
                    {{ displaySaasBoolean(scope.row.processMargin) }}
                </template>
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.date')">
                <template #default="scope">
                    {{ $filters.saasDateFormatted(scope.row.date) }}
                </template>
            </el-table-column>
            <el-table-column
                property="supplier"
                :label="$t.__('documents.overview.tab.margin.supplier')"
            >
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.reference')">
                <template #default="scope">
                    <a
                        v-if="scope.row.canRead"
                        :href="buildLink(scope.row.doctype, scope.row.docid)"
                    >
                        {{ scope.row.ident }}
                    </a>
                    <span v-else>
                        {{ scope.row.ident }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                property="ref"
                :label="$t.__('documents.overview.tab.margin.Purchase.external_reference')"
            >
            </el-table-column>
            <el-table-column
                property="formatted_totalAmount"
                :label="$t.__('documents.overview.tab.margin.purchase_amount_exclude_tax')"
            >
            </el-table-column>
            <el-table-column
                property="formatted_linkedAmount"
                :label="$t.__('documents.overview.tab.margin.Purchase.impacted_amount')"
            >
            </el-table-column>
            <el-table-column v-if="canImpact" fixed="right">
                <template #default="scope">
                    <a class="link mr-2" @click="removeLink(scope.row, context, scope.row)">
                        {{ $l10n.__('Délier') }}
                    </a>
                </template>
            </el-table-column>
        </el-table>

        <div v-if="purchases.length > 0" class="aright fs-3 mt-2">
            <span class="mr-4">
                {{ $l10n.__('Total achat') }} : {{ $filters.numberFormatCurrency(formattedTotal) }}
            </span>
            {{ $l10n.__('Total impact') }} : {{ $filters.numberFormatCurrency(linkedTotal) }}
        </div>
    </div>
</template>

<script>
import MarginMixins from './MarginMixins.js';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('documentOverview');

export default {
    mixins: [MarginMixins],
    data() {
        return {
            context: 'purchase',
        };
    },
    computed: {
        linkedTotal: function () {
            if (this.original.length == 0) {
                return 0;
            }
            return this.original.reduce((accumulator, doc) => {
                return accumulator + parseFloat(doc.linkedAmount);
            }, 0);
        },
        ...mapState({
            purchases: (state) => state.purchases,
            original: (state) => state.purchases.filter((link) => link.processMargin === true),
        }),
    },
    methods: {
        buildLink: function (doctype, docid) {
            return `?_f=purchases_${doctype}Overview&id=${docid}`;
        },
    },
};
</script>
